import { Log } from '@lightningjs/sdk';
import { DetailAction } from './DetailAction';
import { DetailPage } from '../../../pages/detail/DetailPage';
import { Backend } from '../../../api/Backend';
import { AssetType } from '../../../api/models/Shared.types';

export class ShowDetailAction extends DetailAction {
  private _id: string;
  private _type: AssetType;
  constructor(backend: Backend, id: string, type: AssetType) {
    super(backend);
    this._id = id;
    this._type = type;
  }

  override doAction() {
    this.openPage();
  }

  openPage() {
    if (!this._id || !this._type) {
      Log.error('missing id or type on ShowDetailAction');
      return;
    }
    this.owner?.fireAncestors('$openModal', DetailPage, {
      backend: this._backend,
      assetType: this._type,
      assetId: this._id,
    });
  }
}
